/**
 * An IPv4 CIDR block.
 *
 * `address` is the 32-bit address as an unsigned number (0..4294967295) and is not
 * guaranteed to be the network address — call `networkAddress()` to normalise.
 */
export interface Cidr {
  readonly address: number
  readonly prefix: number
}

/** Largest value an IPv4 address can hold. */
export const IPV4_MAX = 0xffffffff

/** Total number of IPv4 addresses. Exceeds a uint32, but exact as a JS number. */
export const IPV4_SPACE = 0x100000000
